import apiClient from '@/lib/api';

export interface DivisionRow {
  id: string;
  name: string;
  externalId: string | null;
  isActive: boolean;
  isHidden: boolean;
  sortOrder: number;
  activeEntityCount: number;
}

/** Admin listing: includes hidden divisions. */
export async function listAllDivisions(): Promise<DivisionRow[]> {
  const { data } = await apiClient.get('/divisions', {
    params: { includeHidden: 'true' },
  });
  return data.data ?? data;
}

export async function updateDivision(
  id: string,
  patch: { isHidden: boolean },
): Promise<DivisionRow> {
  const { data } = await apiClient.patch(`/divisions/${id}`, patch);
  return data.division ?? data;
}
